import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContractAddComponent } from './pages/contract-add/contract-add.component';
import { ContractTypeAddComponent } from './pages/contract-type-add/contract-type-add.component';
import { ContractTypeUpdateComponent } from './pages/contract-type-update/contract-type-update.component';
import { ContractTypeComponent } from './pages/contract-type/contract-type.component';
import { ContractUpdateComponent } from './pages/contract-update/contract-update.component';
import { ContractComponent } from './pages/contract/contract.component';
import { CustomerTerminalAddComponent } from './pages/customer-terminal-add/customer-terminal-add.component';
import { CustomerTerminalUpdateComponent } from './pages/customer-terminal-update/customer-terminal-update.component';
import { CustomerTerminalComponent } from './pages/customer-terminal/customer-terminal.component';
import { DealerReportComponent } from './pages/dealer-report/dealer-report.component';
import { DeviceModelAddComponent } from './pages/device-model-add/device-model-add.component';
import { DeviceModelUpdateComponent } from './pages/device-model-update/device-model-update.component';
import { DeviceModelComponent } from './pages/device-model/device-model.component';
import { GeneralReportComponent } from './pages/general-report/general-report.component';
import { LoginComponent } from './pages/login/login.component';
import { LoginGuard } from './pages/login/login.guard';
import { LogoCustomerComponent } from './pages/logo-customer/logo-customer.component';
import { LogoProjectComponent } from './pages/logo-project/logo-project.component';
import { LogoServiceComponent } from './pages/logo-service/logo-service.component';
import { MovementComponent } from './pages/movement/movement.component';
import { NbsUserComponent } from './pages/nbs-user/nbs-user.component';
import { PortalAddComponent } from './pages/portal-add/portal-add.component';
import { PortalUpdateComponent } from './pages/portal-update/portal-update.component';
import { PortalComponent } from './pages/portal/portal.component';
import { TerminalAddComponent } from './pages/terminal-add/terminal-add.component';
import { TerminalUpdateComponent } from './pages/terminal-update/terminal-update.component';
import { TerminalComponent } from './pages/terminal/terminal.component';


const routes: Routes = [

  { path: "portal", component: PortalComponent, canActivate: [LoginGuard] },
  { path: "portal-add", component: PortalAddComponent, canActivate: [LoginGuard] },
  { path: "portal-update/:portalId", component: PortalUpdateComponent, canActivate: [LoginGuard] },
  { path: "contract-type", component: ContractTypeComponent, canActivate: [LoginGuard] },
  { path: "contract-type-add", component: ContractTypeAddComponent, canActivate: [LoginGuard] },
  { path: "contract-type-update/:contractTypeId", component: ContractTypeUpdateComponent, canActivate: [LoginGuard] },
  { path: "device-model", component: DeviceModelComponent, canActivate: [LoginGuard] },
  { path: "device-model-add", component: DeviceModelAddComponent, canActivate: [LoginGuard] },
  { path: "device-model-update/:deviceModelId", component: DeviceModelUpdateComponent, canActivate: [LoginGuard] },
  { path: "logo-service", component: LogoServiceComponent, canActivate: [LoginGuard] },
  { path: "logo-customer", component: LogoCustomerComponent, canActivate: [LoginGuard] },
  { path: "logo-project", component: LogoProjectComponent, canActivate: [LoginGuard] },
  { path: "contract", component: ContractComponent, canActivate: [LoginGuard] },
  { path: "contract-add", component: ContractAddComponent, canActivate: [LoginGuard] },
  { path: "contract-update/:contractId", component: ContractUpdateComponent, canActivate: [LoginGuard] },
  { path: "terminal", component: TerminalComponent, canActivate: [LoginGuard] },
  { path: "terminal-add", component: TerminalAddComponent, canActivate: [LoginGuard] },
  { path: "terminal-update/:terminalId", component: TerminalUpdateComponent, canActivate: [LoginGuard] },
  { path: "customer-terminal", component: CustomerTerminalComponent, canActivate: [LoginGuard] },
  { path: "customer-terminal-add", component: CustomerTerminalAddComponent, canActivate: [LoginGuard] },
  { path: "customer-terminal-update/:customerTerminalId", component: CustomerTerminalUpdateComponent, canActivate: [LoginGuard] },
  { path: "movement", component: MovementComponent, canActivate: [LoginGuard] },
  { path: "nbs-user", component: NbsUserComponent, canActivate: [LoginGuard] },
  { path: "general-report", component: GeneralReportComponent, canActivate: [LoginGuard] },
  { path: "dealer-report", component: DealerReportComponent, canActivate: [LoginGuard] },
  // { path: "dealer", component: DealerComponent, canActivate: [LoginGuard] },
  // { path: "dealer-add", component: DealerAddComponent, canActivate: [LoginGuard] },
  // { path: "dealer-update/:dealerId", component: DealerUpdateComponent, canActivate: [LoginGuard] },

  { path: "login", component: LoginComponent },
  { path: "", redirectTo: "login", pathMatch: "full" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
